import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@common/http/query-client';
import { BackendResponse } from '@common/http/backend-response/backend-response';

export const ALBUM_TYPE_MODEL = 'album_type';

export interface AlbumType {
  id: number;
  name: string;
  slug: string;
  artist_types: string;
  object: string;
  image: string;
  model_type: 'album_type';
}

export interface AlbumSubtype {
  id: number;
  name: string;
  slug: string;
  album_type_id: number; // Relation avec AlbumType
}

interface ResponseTaxonomies extends BackendResponse {
  types: AlbumType[];
  subtypes: AlbumSubtype[];
}
export function useAlbumTaxonomies() {
  return useQuery({
    queryKey: ['albumTaxonomies'],
    queryFn: () => fetchAlbumTaxonomies(),
  });
}
async function fetchAlbumTaxonomies() {
  return apiClient
    .get<ResponseTaxonomies>(`album/taxonomies`)
    .then(response => response.data);
}


interface ResponseAlbumTaxonomyTypes extends BackendResponse {
  types: AlbumType[];
}
export function useAlbumTaxonomyTypes() {
  return useQuery({
    queryKey: ['albumTaxonomyTypes'],
    queryFn: () => fetchAlbumTaxonomyType(),
  });
}
async function fetchAlbumTaxonomyType() {
  return apiClient
    .get<ResponseAlbumTaxonomyTypes>(`album/taxonomies/types`)
    .then(response => response.data);
}

interface AlbumTaxonomySubtypesParams {
  typeId: number;
}
interface ResponseAlbumTaxonomySubtypes extends BackendResponse {
  subtypes: AlbumSubtype[];
}
export function useAlbumTaxonomySubtypes({typeId}: AlbumTaxonomySubtypesParams) {
  return useQuery({
    queryKey: ['albumTaxonomySubytpes', +typeId!],
    queryFn: () => fetchAlbumTaxonomySubtype(),
  });
}
async function fetchAlbumTaxonomySubtype() {
  return apiClient
    .get<ResponseAlbumTaxonomySubtypes>(`album/taxonomies/subtypes`)
    .then(response => response.data);
}



